import React from 'react';

import { HeaderWithBreadcrumbs, BreadcrumbLink } from '../../../../../base/components/HeaderWithBreadcrumbs';
import { __t } from '../../../../../base/utils/t';
import { VacancyTableFilter } from '../../enums';
import { VacancyTable as VacancyTableComponent } from '../../components/VacancyTable';
import { useIsMobile } from '../../../../../base/hooks';
import { VacancyMobileList } from '../../components/VacancyMobileList';
import { Helmet } from '../../../../components/Helmet';

import './styles.scss';

interface Props {
    filter: VacancyTableFilter;
}

export const VacancyTable = ({ filter }: Props) => {
    const isMobile = useIsMobile();
    const breadcrumbs: BreadcrumbLink[] = [
        {
            text: __t('Главная'),
            url: '/',
        },
        {
            text: __t('Мой профиль'),
            url: '/employer/update',
        },
    ];

    return (
        <>
            <Helmet pageName={__t('Мои вакансии')} />
            <HeaderWithBreadcrumbs links={breadcrumbs} current={__t('Мои вакансии')} title={__t('Мои вакансии')} />
            <div className='vacancy-list-page'>
                {isMobile ? <VacancyMobileList filter={filter} /> : <VacancyTableComponent filter={filter} />}
            </div>
        </>
    );
};
